import { addDataDogError } from '../../utils/datadog/datadog.utils';
import { AxiosError } from 'axios';
import { cityPairStringToArray } from '../../utils/cityPairs.utils';
import { dateRangesToISORanges } from '../../utils/date.utils';
import { ENDPOINT_URLS } from '../../constants';
import { useAxios } from '../../utils/transport/useAxios';

import { CityPairString, DateRange, DaysBeforeDeparture, DaysOfTheWeek } from '../../types';

export function usePostCreateRule() {
    const apiClient = useAxios();

    const createRule = async (
        title: string,
        tags: string[],
        active: boolean,
        cityPairs: CityPairString[],
        includedDates: DateRange[],
        excludedDates: DateRange[],
        daysOfTheWeek: DaysOfTheWeek,
        daysBeforeDeparture: DaysBeforeDeparture,
        alpha: number,
        notifyOnOverlap: boolean,
    ): Promise<[boolean, string]> => {
        let success = false;
        let errorMessage = '';
        try {
            const cityUUIDs = cityPairs.map((cityPair) => cityPairStringToArray(cityPair));
            if (cityUUIDs.length > 0) {
                const res = await apiClient.post(ENDPOINT_URLS.CREATE_RULE, {
                    title: title,
                    tags: tags,
                    active: active,
                    city_pairs: cityUUIDs,
                    included_dates: dateRangesToISORanges(includedDates),
                    excluded_dates: dateRangesToISORanges(excludedDates),
                    days_of_the_week: daysOfTheWeek,
                    days_before_departure:
                        daysBeforeDeparture[0] === 365 && daysBeforeDeparture[1] === 0 ? [] : daysBeforeDeparture,
                    alpha: alpha,
                    notify_on_overlap: notifyOnOverlap,
                });

                if (res.status !== 201) {
                    throw `Error with status ${res.headers}`;
                }

                success = true;
            }
        } catch (e) {
            if (e instanceof AxiosError) {
                addDataDogError(e as Error);
                errorMessage = e.message;
            } else {
                addDataDogError(e as Error);
                errorMessage = e as string;
            }
        }

        return [success, errorMessage];
    };

    return { createRule };
}
